import { deprecated } from 'typesafe-actions'

import { ProjectId, Project } from '../../interfaces/entities/project'
import { Result, Descriptive, IAppError } from '../../interfaces/base'
import { Creative, CreativeAction } from '../../interfaces/entities/creative'
import { Formatset, FormatsetId } from '../../interfaces/entities/formatset'
import { Platform } from '../../interfaces/entities/platform'

const { createAction } = deprecated

export const getProject = createAction(
  'project_overview/GET_PROJECT',
  (resolve) => {
    return (project: ProjectId) => resolve(project)
  },
)

export const getProjectComplete = createAction(
  'project_overview/GET_PROJECT_COMPLETE',
  (resolve) => {
    return (response: Result<Project, IAppError>) => resolve(response)
  },
)

export const doCreativeAction = createAction(
  'project_overview/DO_CREATIVE_ACTION',
  (resolve) => {
    return (creative: Creative, action: CreativeAction) =>
      resolve({ creative, action })
  },
)

export const doCreativeActionComplete = createAction(
  'project_overview/DO_CREATIVE_ACTION_COMPLETE',
  (resolve) => {
    return (
      response: Result<
        { action: CreativeAction; creative: Creative; message: string },
        IAppError
      >,
    ) => resolve(response)
  },
)

export const doProjectAction = createAction(
  'project_overview/DO_PROJECT_ACTION',
  (resolve) => {
    return (action: Descriptive, project: Project) =>
      resolve({ action, project })
  },
)

export const doProjectActionComplete = createAction(
  'project_overview/DO_PROJECT_ACTION_COMPLETE',
  (resolve) => {
    return (response: Result<Project, IAppError>) => resolve(response)
  },
)

export const saveProject = createAction('project/SAVE_PROJECT', (resolve) => {
  return (project: Project) => resolve(project)
})

export const saveProjectCompleted = createAction(
  'project_overview/SAVE_PROJECT_COMPLETED',
  (resolve) => {
    return (result: Result<Project, IAppError>) => resolve(result)
  },
)

export const addedFormatsets = createAction(
  'project_overview/ADDED_FORMATSET',
  (resolve) => {
    return (formatsets: Formatset[]) => resolve(formatsets)
  },
)

export const setProjectComment = createAction(
  'project_overview/SET_FPROJECT_COMMENT',
  (resolve) => {
    return (projectId: ProjectId, comment: string) =>
      resolve({ projectId, comment })
  },
)

export const removeFormatSet = createAction(
  'project_overview/REMOVE_FORMATSET',
  (resolve) => {
    return (formatsetId: FormatsetId) => resolve(formatsetId)
  },
)

export const leaveProjectPage = createAction(
  'project_overview/LEAVE_PROJECT_PAGE',
)

export const getPlatforms = createAction(
  'project_overview/GET_PLATFORMS',
  (resolve) => {
    return () => resolve()
  },
)

export const getPlatformsComplete = createAction(
  'project_overview/GET_PLATFORMS_COMPLETE',
  (resolve) => {
    return (response: Result<Platform[], IAppError>) => resolve(response)
  },
)
